import { useEffect, useState } from 'react';
import { getMasterEquipmentPartHistoriesByQuery } from 'components/axios/equipmentCategoryAxios';
import { getEquipmentPartHistoriesByQuery } from 'components/axios/equipmentAxios';
import { formatHourToText } from 'data/data';
import { useTranslation } from 'react-i18next';

const AvgLifeTime = ({masterEquipmentPartId, componentLocationId, useLife=null}) => {
    const { t } = useTranslation();
    const [avgLifeTime, setAvgLifeTime] = useState(null);
    const [overLifeColor, setOverLifeColor] = useState('#fff');

    useEffect(()=>{
        if (masterEquipmentPartId) {
            if (componentLocationId) {
                getEquipmentPartHistoriesByQuery({masterEquipmentPartId, componentLocationId}).then((data)=>{
                    if (data && data._embedded && data._embedded.equipmentPartHistories) {
                        setAvgLifeTime(data._embedded.equipmentPartHistories[0].avgLifeTime);
                        return data._embedded.equipmentPartHistories[0].avgLifeTime;
                    } else {
                        setAvgLifeTime(null);
                        return 0;
                    }
                }).then((res)=>{
                    if (useLife) {
                        if (useLife > res) {
                            setOverLifeColor('red')
                        } else {
                            setOverLifeColor('#fff')
                        }
                    }
                })
            } else {
                getMasterEquipmentPartHistoriesByQuery({masterEquipmentPartId}).then((data)=>{
                    if (data && data._embedded && data._embedded.masterEquipmentPartHistories) {
                        setAvgLifeTime(data._embedded.masterEquipmentPartHistories[0].avgLifeTime);
                        return data._embedded.masterEquipmentPartHistories[0].avgLifeTime;
                    } else {
                        setAvgLifeTime(null);
                        return 0;
                    }
                }).then((res)=>{
                    if (useLife) {
                        if (useLife > res) {
                            setOverLifeColor('red')
                        } else {
                            setOverLifeColor('#fff')
                        }
                    }
                })
            }
        }
    },[masterEquipmentPartId, componentLocationId]);

    return (
        <span style={{color:`${overLifeColor}`}}>{formatHourToText(avgLifeTime, t)}</span>
    )
}

export default AvgLifeTime;